/**
 * Stable CSS class names for E2E — Customer device details grid.
 */
export const GCDD = {
    page: 'customer-device-details-page',
    datagrid: 'customer-device-details-page__datagrid',
} as const;

export const gcddCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
